import { Board } from "./Board"

export const DndList = Board
